import {connect} from 'react-redux';

import {CalendarsPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {CalendarVersionModel} from '../../../models/api/calendarVersionModel';
import {selectUniqueCalendarVersionTransientAction} from '../../../store/panels/calendars/calendarsPanelActions';
import {CalendarsListItemDropdown} from './calendarsListItemDropdown';

/*
 * Props.
 */

interface CalendarsListItemDropdownContainerProps {
  panelId: CalendarsPanelId;
  calendarVersion: CalendarVersionModel;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<CalendarsListItemDropdownContainerProps>()((props) => {
  const {panelId, calendarVersion} = props;
  return {
    onShowOnlyClick: () => selectUniqueCalendarVersionTransientAction(panelId, calendarVersion.id),
  };
});

export const CalendarsListItemDropdownContainer = connect(
  null,
  mapDispatchToProps,
)(CalendarsListItemDropdown);
